export default "__VITE_ASSET__d0303038__"